import { render, staticRenderFns } from "./submitBtn.vue?vue&type=template&id=4f95364a&scoped=true&"
import script from "./submitBtn.vue?vue&type=script&lang=ts&"
export * from "./submitBtn.vue?vue&type=script&lang=ts&"
import style0 from "./submitBtn.vue?vue&type=style&index=0&id=4f95364a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f95364a",
  null
  
)

export default component.exports